import {integritySector} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadIntegritySector(selection: any) {
  return useLoad(integritySector, 'revision', {values: selection});
}

export default useLoadIntegritySector;
